goog.provide("shadow.js.shim.module$react_dropzone");
goog.provide("module$shadow_js_shim_module$react_dropzone");
shadow.js.shim.module$react_dropzone = shadow.js.nativeProvides["react-dropzone"] = shadow$bridge("react-dropzone");
module$shadow_js_shim_module$react_dropzone.default = shadow.js.shim.module$react_dropzone;
